import { render, staticRenderFns } from "./CompanyAds.vue?vue&type=template&id=0ab0bc9c"
import script from "./CompanyAds.vue?vue&type=script&lang=js"
export * from "./CompanyAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports